import styled from 'styled-components';
import {
    Ellipticable,
    getEllipticableCss,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
    OpenableOverlay,
    Stack,
    StackProps,
} from '@optimus-web/core';

export const PopoverElement = styled.div`
    background: ${getToken('backgroundStaticFloating')};
    box-shadow: ${getToken('shadow200')};
    border-radius: ${getToken('borderRadius100')}px;
    padding: ${getSpacingToken('150')}px;
`;

export const Arrow = styled.div`
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
`;

export const StyledOpenableOverlay = styled(OpenableOverlay)`
    padding: ${getSpacingToken('50')}px;
    background: none;
    box-shadow: none;
    overflow: initial !important;

    &[data-popper-placement='bottom'] {
        ${Arrow} {
            border-width: 0 4px 4px 4px;
            border-color: transparent transparent ${getToken('backgroundStaticFloating')} transparent;
            top: 0;
        }
    }
    &[data-popper-placement='top'] {
        ${Arrow} {
            border-width: 4px 4px 0 4px;
            border-color: ${getToken('backgroundStaticFloating')} transparent transparent transparent;
            bottom: 0;
        }
    }
    &[data-popper-placement='right'] {
        ${Arrow} {
            border-width: 4px 4px 4px 0;
            border-color: transparent ${getToken('backgroundStaticFloating')} transparent transparent;
            left: 0;
        }
    }
    &[data-popper-placement='left'] {
        ${Arrow} {
            border-width: 4px 0 4px 4px;
            border-color: transparent transparent transparent ${getToken('backgroundStaticFloating')};
            right: 0;
        }
    }
`;

export const PopoverHeaderElement = styled(Stack)<StackProps>`
    margin-bottom: ${getSpacingToken('150')}px;
`;

export const PopoverTitle = styled.h2<Ellipticable>`
    margin: ${getSpacingToken('0')};
    color: ${getToken('textStaticPrimary')};
    ${getTextTokenPreset('titleSmallStrong')};
    ${getEllipticableCss}
`;

export const PopoverSubtitle = styled.p`
    margin: ${getSpacingToken('0')};
    color: ${getToken('textStaticPrimary')};
    ${getTextTokenPreset('bodySmall')};
`;
